import { FiTimeZonesService } from '@fi-shared/fi-shared-services/fi-time-zones.service';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { Injector } from '@angular/core';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { ICreateChangeBase } from '@fi-shared/models/models';
import { AvailableDateTimeLocale } from '@fi-shared/utils';

export interface IAreaModel extends ICreateChangeBase {
    Id: number;
    ParentId: number;
    Name: string;
    Description: string;
    Names: IContentLanguageLabelModel[];
    Descriptions: IContentLanguageLabelModel[];
    IsSystemObject: boolean;
    ChildItems: any[];

    TotalBusinessUnitsCount: number;
    ActiveBusinessUnitsCount: number;
    UsersCount: number;
    TimeZoneName: string;
    PhoneCountryId: number;
    PreferredDateFormat: AvailableDateTimeLocale;
    PreferredTimeFormat: AvailableDateTimeLocale;
}

export class LightWeightAreaModel {
    Id = 0;
    Name = '';
    ChildItems: Array<any> = [];
    PreferredDateFormat: AvailableDateTimeLocale;
    PreferredTimeFormat: string;
    $$level: number;
}

export class AreaModel extends LightWeightAreaModel {
    Description = '';
    ParentId = null;
    Names: IContentLanguageLabelModel[] = [];
    Descriptions: IContentLanguageLabelModel[] = [];
    CreatedByUserId = 0;
    CreatedByUserName = '';
    CreatedOn: string; //ISO 8601 date
    ChangedByUserId = 0;
    ChangedByUserName = '';
    ChangedOn: string; //ISO 8601 date
    IsSystemObject = false;
    //ParentArea = null;
    ParentName = '';
    TotalBusinessUnitsCount = 0;
    ActiveBusinessUnitsCount = 0;
    UsersCount = 0;
    TimeZoneName = FiTimeZonesService.DefaultTimeZoneName;
    PhoneCountryId: number;

    constructor(areaItem: IAreaModel, injector: Injector) {
        super();

        this.initialize(areaItem || <IAreaModel>{}, injector);
    }

    private initialize(area: IAreaModel, injector: Injector) {
        this.Id = area.Id;
        this.Name = area.Name;
        this.Description = area.Description;
        this.ParentId = area.ParentId;
        this.CreatedByUserId = area.CreatedByUserId;
        this.CreatedByUserName = area.CreatedByUserName;
        this.CreatedOn = area.CreatedOn;
        this.ChangedByUserId = area.ChangedByUserId;
        this.ChangedByUserName = area.ChangedByUserName;
        this.ChangedOn = area.ChangedOn;
        this.IsSystemObject = area.IsSystemObject || false;
        //this.ParentArea = area.ParentArea;
        this.TotalBusinessUnitsCount = area.TotalBusinessUnitsCount;
        this.ActiveBusinessUnitsCount = area.ActiveBusinessUnitsCount;
        this.UsersCount = area.UsersCount;
        this.TimeZoneName = area.TimeZoneName;
        this.PhoneCountryId = area.PhoneCountryId;
        this.PreferredDateFormat = area.PreferredDateFormat;
        this.PreferredTimeFormat = area.PreferredTimeFormat;

        if (area.ChildItems && area.ChildItems.length > 0) {
            area.ChildItems.forEach((item) => {
                const child = new AreaModel(item, injector);
                child.ParentName = area.Name;

                this.ChildItems.push(child);
            });
        }

        const contentLanguagesService = injector.get(ContentLanguagesService);
        contentLanguagesService.InitializeContentLanguagesArray(this.Names, area.Names, true);
        contentLanguagesService.InitializeContentLanguagesArray(this.Descriptions, area.Descriptions, true);
    }
}
